import BlogPostLayout from "@/components/BlogPostLayout";
import { getPost } from "@/content/blogPosts";
import NotFound from "@/pages/NotFound";

/** Renders a single blog article for its dedicated route. */
const ArticlePage = ({ slug }: { slug: string }) => {
  const post = getPost(slug);
  if (!post) return <NotFound />;
  return <BlogPostLayout post={post} />;
};

export default ArticlePage;